import React, { FC, useEffect } from 'react';
import { ActiveReserveConfigurations } from '../../components/funds-reserve-config/ActiveReserveConfigurations';
import { InactiveConfigurationHistory } from '../../components/funds-reserve-config/InactiveConfigurationHistory';
// import { ButtonComponent } from '../../components/ButtonComponent';
import {
	fetchFundsReserveConfigActive,
	fetchFundsReserveConfigInactive,
	fetchFundsReserveConfigLists,
} from '../../store/merchnts/actions/fundsReserveConfig';
import { useMerchants } from '../../store/merchnts/merchants-context';

export const FundsReserveConfigList: FC = () => {
	const { dispatch } = useMerchants();

	useEffect(() => {
		void fetchFundsReserveConfigLists(dispatch);
		void fetchFundsReserveConfigActive(dispatch);
		void fetchFundsReserveConfigInactive(dispatch);
	}, []);

	return (
		<>
			{/*<ButtonComponent*/}
			{/*	buttonName="Add Configuration"*/}
			{/*	additionalClass="btn-sm d-block ms-auto mb-5"*/}
			{/*/>*/}
			<ActiveReserveConfigurations/>
			<InactiveConfigurationHistory/>

		</>
	);
};